import * as types from './actionTypes';  
import checkPlannerApplicationApi from '../api/checkPlannerApplicationApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2';
import { loadingRes } from './loadingActions';

export function doCheckPlannerApp() {
  return {
    type: types.DO_CHECK_PLANNER_APP
  };
}

export function doCheckPlannerAppRes(data) {  
  return {
    type: types.DO_CHECK_PLANNER_APP_RES, 
    data
  };
}

export function checkPlannerApp() {
  const TOKEN = getItem('auth_token');
  if(TOKEN){
    return function(dispatch) {
      dispatch(loadingRes(true));
      checkPlannerApplicationApi.doCheckPlannerApp().then(data => {
        dispatch(doCheckPlannerAppRes(data));
        dispatch(loadingRes(false));
        if(data.error){
          Swal.fire({
            title: data.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          });
        }
      }).catch(error => {
        dispatch(loadingRes(false));
        return error
      });
    };
  }else{
    logout()
  }
}